
function Notifications({ children }) {
  return children
}

export default Notifications



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js